import React from 'react'
import {
  MdFolderShared,
  MdSchool,
  MdWatchLater,
  MdDashboard,
  MdPeople
  // eslint-disable-next-line import/no-extraneous-dependencies
} from 'react-icons/md'
import routes from '../config/routes'

export const PROFILE_ITEM_ID = 990

export const DASHBOARD_OPTION_ID = 99999

export const MENU_LIST = [
  {
    optionId: DASHBOARD_OPTION_ID,
    route: '/dashboard',
    icon: <MdDashboard size={24} color="#FFFFFF" opacity={0.4} />
  },
  {
    optionId: DASHBOARD_OPTION_ID,
    route: '/dashboard',
    icon: <MdDashboard size={24} color="#FFFFFF" opacity={0.4} />
  },
  {
    optionId: 18,
    route: routes.wallet.path,
    icon: <MdFolderShared size={24} color="#FFFFFF" opacity={0.4} />
  },
  {
    optionId: 48,
    route: routes.content.path,
    icon: <MdSchool size={24} color="#FFFFFF" opacity={0.4} />
  },
  {
    optionId: 33,
    route: routes.timeline.path,
    icon: <MdWatchLater size={24} color="#FFFFFF" opacity={0.4} />
  },
  {
    optionId: 139,
    route: routes.people.list.path,
    icon: <MdPeople size={24} color="#FFFFFF" opacity={0.4} />
  },
  {
    optionId: 65,
    route: routes.dashboard.path.replace(':roleId', 65),
    icon: <MdDashboard size={24} color="#FFFFFF" opacity={0.4} />
  },
  {
    optionId: 66,
    route: routes.dashboard.path.replace(':roleId', 66),
    icon: <MdDashboard size={24} color="#FFFFFF" opacity={0.4} />
  }
]
